import { useQuery } from '@apollo/client';
import ShippingOptionsQuery from './ShippingOptionsQuery';
import React from 'react';
import { ShippingOptionsResponseData } from './types';

type result = {
  loading: boolean;
  shippingOptions?: ShippingOptionsResponseData;
};

interface IShippingOptionsConnectorApollo {
  children: (result: result) => React.ReactElement;
}

const ShippingOptionsConnectorApollo: React.FC<IShippingOptionsConnectorApollo> = ({
  children,
}) => {
  const { loading, error, data } = useQuery(ShippingOptionsQuery);

  const result: result = {
    loading,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    result.shippingOptions = data.sale.shippingOptions;
  }

  return children(result);
};

export default ShippingOptionsConnectorApollo;
